import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const WhatsAppWidget = () => {
    const { t } = useTranslation();
    const phoneNumber = import.meta.env.VITE_WHATSAPP_NUMBER;

    if (!phoneNumber) return null;

    return (
        <a
            href={`https://wa.me/${phoneNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            aria-label={t('common.whatsapp_contact')}
            title={t('common.whatsapp_contact')}
        >
            <MessageCircle className="h-8 w-8" />
        </a>
    );
};

export default WhatsAppWidget;
